<template>
  <div class="strategicContractList">
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <div class="main-content">
      <sirui-table
        :rowKey="propCode || 'id'"
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :showFooter="false"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :min-width="120"
          :sortable="item.sortable"
          :field="item.field"
          :formatter="item.formatter"
          :params="item.params"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.type == 'seq'">
              {{ scope.rowIndex + 1 }}
            </span>
            <span v-else-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else-if="item.optionList">
              {{ getSelectLabel(scope.row[item.field], item.optionList) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <sirui-upload
      :action="action"
      @getData="getData"
      ref="SiruiUpload"
      :data="token"
    ></sirui-upload>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/futuresStrategy/index';
  import siruiUpload from '@/components/SiruiUpload';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import tableMixins from '@/common/mixins/table.js';
  // import DataBaseAPI from '@/api/dataBase';
  import XEUtils from 'xe-utils';
  export default {
    name: 'strategicContractList',
    mixins: [tableMixins],
    components: {
      siruiUpload,
      SiruiSearch,
      SiruiTable,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        categoryList: function (state) {
          let salesList = state.dict.dictListMap.sales_contract_detail_category;
          let purchaseList = state.dict.dictListMap.purchase_contract_detail_category;
          return salesList.concat(purchaseList);
        },
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          {
            // 策略编号
            prop: 'ptcombiNo',
            name: this.$t('futuresStrategy.strategicContract.column.ptcombiNo'),
            type: 'input',
          },
        ];
      },
      columnListDefault() {
        return [
          //{ type: "checkbox", width: "50", fixed: "left" }, // 复选框
          { type: 'seq', visible: true, width: '50', fixed: 'left', title: 'table.index' }, //序号
          {
            field: 'ptcombiNo',
            title: 'futuresStrategy.strategicContract.column.ptcombiNo',
            width: 220,
          }, // 策略编号
          { field: 'combiName', title: 'futuresStrategy.strategicContract.column.combiName' }, // 策略名称
          {
            field: 'exchangeTypeMode',
            title: 'futuresStrategy.strategicContract.column.exchangeTypeMode',
            dictType: 'strategy_model',
          }, // 策略模式
          { field: 'productName', title: 'futuresStrategy.strategicContract.column.projectName' }, // 项目名称
          { field: 'branchName', title: 'futuresStrategy.strategicContract.column.departmentName' }, // 业务部门
          { field: 'contractNo', title: 'futuresStrategy.strategicContract.column.contractNo' }, // 合同编号
          {
            field: 'contractDetailNo',
            title: 'futuresStrategy.strategicContract.column.contractDetailNo',
          }, // 合同行
          { field: 'productDesc', title: 'futuresStrategy.strategicContract.column.productDesc' }, // 商品描述
          { field: 'contractDate', title: 'futuresStrategy.strategicContract.column.contractDate' }, // 合同日期
          {
            field: 'contractDetailCategory',
            title: 'futuresStrategy.strategicContract.column.contractDetailCategory',
            optionList: this.categoryList,
          }, // 合同类型
          {
            field: 'contractStatusName',
            title: 'futuresStrategy.strategicContract.column.contractStatus',
          }, // 合同执行情况
        ];
      },
    },
    data() {
      return {
        action: API.IMPORT_PDEXPENSEDETAIL,
        exportAction: API.PROCOMBI_CONTRACT_EXPORT,
        query: {
          ptcombiNo: null,
        },
        departmentList: [],
        propCode: 'ptcombiNo',
      };
    },
    mounted() {
      this.getData();
      this.getButtonList();
    },
    methods: {
      getData() {
        // 获取列表数据
        this.load = true;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        let params = { ...this.query, pageNum, pageSize };
        this.$axios.post(API.LIST_PROCOMBI_CONTRACT_BY_PAGE, params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
            //重新加载表格
            this.$refs.siruiTable.reloadTable(this.tableData);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      chooseClick(type) {
        if (type == 'add') {
          // 新增
          this.toPath('strategicContractAdd', {});
        } else if (type == 'edit') {
          // 修改
          if (this.multipleSelection.length != 1) {
            return this.tips('xTable.selectOne', 'error');
          }
          this.toPath('expenseEdit', { id: this.multipleSelection[0].id });
        } else if (type == 'del') {
          // 删除
          this.handleDel();
        } else if (type == 'exportData') {
          // 导出
          this.exportData();
        } else if (type == 'import') {
          // 导入
          this.handleImport();
        }
      },

      //编辑表格回显方法
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },

      dblclickEvent(value) {
        // 列表双击
        this.toPath('strategicContractDetail', { ptcombiNo: value.row.ptcombiNo });
      },

      exportData() {
        const params = XEUtils.serialize(this.query);
        window.location.href = `${this.baseUrl}${API.PROCOMBI_CONTRACT_EXPORT}?${params}&access_token=${this.token.access_token}`;
      },
      tips(info, type) {
        // 提示
        this.$message({ showClose: true, message: this.$t(info), type: type });
      },
      toPath(name, query) {
        // 跳转路径
        let path = {
          path: `/futuresStrategy/${name}`,
          name: name,
          meta: {
            keepAlive: true,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
